export interface GlobalState {
    user: any;
}

export const defaultGlobalState: GlobalState = {
    user: undefined
}